import ShopType from "@/enum/ShopType";

export const CouponUrlMapping = {};

export const CouponImagUrlMapping = {};

export const CouponSidebarUrlMapping = {};

export const CouponCloseImgUrlMapping = {};
